import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { SignerService } from './dependents/service/SignerService';
import { getIIRISCookie,logOutSession } from './dependents/common/IdentityUtils';


(function (window) {
  function initIIRISProfileMgr() {
    const apiBaseURL = process.env.API_BASE_URL;  
    let profileMgrObj = {

      //function to refresh auth token every 30 min
      async getProfileByRefreshingAuth(data={}) {
        // IRIS_HASH is refresh token 
        const passToken = getIIRISCookie("IRIS_HASH");
        const api_client_id = data?.client_id;
        if (api_client_id && passToken) {
          //step1:Get the Refreshed token using API
          //step2:Set the Client id
          //step3:Get the Profile only for the first time when script is loaded
          if (this.getRefreshedAuth && this.setIIRISCookie && getIIRISCookie) {
            this.getRefreshedAuth(api_client_id, passToken, this.setIIRISCookie, getIIRISCookie);
          }
          else {
            this.IIRISProfileMgr.getRefreshedAuth(api_client_id, passToken, this.IIRISProfileMgr.setIIRISCookie, getIIRISCookie);
          }
        }
        setInterval(this.getProfileByRefreshingAuth, 1800000); //call every 30 mins
      },

      //function to get refreshAuth token using API
      getRefreshedAuth(apiClientId,passToken, setCookie, getCookie) {
        let isLinkedInLogin = false;
        let isSocialLogin = false;
        let email = "";
        let client_id = process.env.REACT_APP_PASSPORT_SOCIAL_LOGIN_APP_CLIENT_ID;
        const idToken = getCookie("IRIS_IDT");
        const payload = {};
        if (idToken) {
          const decodedToken = jwtDecode(idToken);
          if (decodedToken.email.includes("linkedin.")) {
            isLinkedInLogin = true;
            email = decodedToken.email.replace("linkedin.", "");
          }
          else if (decodedToken.identities) {
            isSocialLogin = true;
          }
        }
        if (apiClientId && !isSocialLogin) {
          client_id = apiClientId;
        }
        if (isLinkedInLogin) {
          payload["linkedin_email"] = email;
          payload["client_id"] = client_id;
        } else {
          payload["refresh_token"] = passToken;
          payload["client_id"] = client_id;
        }

        try {
          const url = apiBaseURL + `/v3/authorization/public/refreshAuthToken${isLinkedInLogin ? `?m2m=true` : ''}`;
          const result = SignerService({
            method:"POST",
            url,
            body:payload
          }).then(function (response) {
            const refreshedAuthToken = response.data.access_token;
            const expiry = response.data.expires_in || 86400;
            const authFlow = localStorage.getItem('auth_flow') ? localStorage.getItem('auth_flow') : 'anonymous';
            //Set the cookie
            //setCookie("IRIS_AUTH", refreshedAuthToken);
            document.cookie = `IRIS_AUTH=${refreshedAuthToken}; path=/; max-age=${expiry}; samesite=strict; secure;domain=${window.location.hostname}`;

            //Get the Profile
            const irisId = getCookie("IRIS_ID");
            const authToken = getCookie("IRIS_AUTH");
            const appId = getCookie("IRIS_APPID");
            if (irisId && authToken) {
              axios
                .get(apiBaseURL + "/v3/audience/profile/" + irisId + "/"+ appId, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + authToken,
                  },
                })
                .then((audResponse) => {
                  if (audResponse.status === 200) {
                    let userObj = audResponse.data.data[0];
                    userObj.profile_picture = localStorage.getItem("profile_picture") ? localStorage.getItem("profile_picture") : ""
                    userObj.is_social_login = JSON.parse(localStorage.getItem("is_social_login"))
                    if (window.irisProfileMgrCallback) {
                      const callbackObj = { "success": true, "user": userObj, "token": authToken }
                      window.irisProfileMgrCallback(callbackObj);
                    }
                  } else {
                    if (window.irisProfileMgrCallback) {
                      const callbackObj = { "success": false, "user": null, "token": null }
                      window.irisProfileMgrCallback(callbackObj);
                    }
                  }
                })
                .catch((e) => {
                  if (window.irisProfileMgrCallback) {
                    const callbackObj = { "success": false, "user": null, "token": null }
                    window.irisProfileMgrCallback(callbackObj);
                  }
                });
            } else {
              if (window.irisProfileMgrCallback) {
                const callbackObj = { "success": false, "user": null, "token": null }
                window.irisProfileMgrCallback(callbackObj);
              }
            }

          })
            .catch((e) => {
              if (window.irisProfileMgrCallback) {
                const callbackObj = { "success": false, "user": null, "token": null }
                window.irisProfileMgrCallback(callbackObj);
              }
            });
          return result;
        } catch (error) {
          console.log("error", error);
          return error.response;
        }
      },

      //function to get taxonomy data by passing QuestionID or QuestionPath, Division and Brand
      getTaxonomyData(path) {
        return SignerService({
          url:'GET',
          url:apiBaseURL + '/v2/taxonomy/public/' + path,
        }).then((data) => {
          return data;
        }).catch((error) => {
          console.log("error", error);
          return error.response;
        });
      },

      //function refresh token to fetch User Profile using Audience API 
      getIIRISProfile(data={}) {
        const passToken = getIIRISCookie("IRIS_HASH");
        if(!passToken){
           logOutSession();
        } else {
          this.getProfileByRefreshingAuth(data);
        }
      },

      //Profile POST 
      setIIRISProfile(userObj) {
        const authToken = getIIRISCookie("IRIS_AUTH");
        const irisId = getIIRISCookie("IRIS_ID");
        const appId = getIIRISCookie("IRIS_APPID");
        try {
          const url = apiBaseURL + "/v3/audience/profile/update/"+irisId+"/"+appId;
          const jwtToken = authToken;
          const options = {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "Authorization": jwtToken,
            },
            data: userObj,
            url,
          };
          const result = axios(options).then(function (response) {
            let responseData = response.data;
            const isSocialLoginStr = localStorage.getItem('is_social_login');
            if (isSocialLoginStr) {
              responseData.data[0].is_social_login = JSON.parse(isSocialLoginStr);
            }
            return responseData;
          });
          return result;
        } catch (error) {
          console.log("error", error);
          return error.response;
        }
      },

      //GET Registration Details 
      getIIRISRegistrationDetails(productId) {
        const authToken = getIIRISCookie("IRIS_AUTH");
        const irisId = getIIRISCookie("IRIS_ID");
        try {
          const url = `${apiBaseURL}/v3/audience/registration/${irisId}/${productId}`;
          const jwtToken = authToken;
          const options = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": jwtToken,
            },
            url,
          };
          const result = axios(options).then(function (response) {
            return response.data;
          });
          return result;
        } catch (error) {
          console.log("error", error);
          return error.response;
        }
      },

      //GET Consent Details 
      getIIRISConsent(version) {
        const authToken = getIIRISCookie("IRIS_AUTH");
        const irisId = getIIRISCookie("IRIS_ID");
        try {
          const url = `${apiBaseURL}/v3/audience/consent/iid/${irisId}/${version}`;
          const jwtToken = authToken;
          const options = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": jwtToken,
            },
            url,
          };
          const result = axios(options).then(function (response) {
            return response.data;
          });
          return result;
        } catch (error) {
          console.log("error", error);
          return error.response;
        }
      },

      //function to set/update auth in cookie
      setIIRISCookie(cName, cValue, expiry) {
        document.cookie =`${cName}= ${cValue}; path=/; max-age=${expiry}; samesite=strict; secure; domain=${window.location.hostname}`;
      },
    };
    return profileMgrObj;
  }

  if (typeof window.IIRISProfileMgr === "undefined") {
    window.IIRISProfileMgr = initIIRISProfileMgr();
  }
  window.IIRISProfileMgr.getIIRISProfile();
})(window);
